module.exports = __webpack_public_path__ + "img/terracenew_box09.14498f44.jpg";